import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Portfolio Map State Types
export type PortfolioSiteExplorerUIState = {
    isSidebarOpen: boolean;
    selectedMetric: string;
    hoveredSiteId: string | null;
    selectedSiteId: string | null;
    mapType: string;
    view: 'map' | 'list';
};

const initialState: PortfolioSiteExplorerUIState = {
    isSidebarOpen: true,
    selectedMetric: 'NA',
    hoveredSiteId: null,
    selectedSiteId: null,
    mapType: 'roadmap',
    view: 'map',
};

const portfolioSiteExplorerSlice = createSlice({
    name: 'portfolioSiteExplorer',
    initialState,
    reducers: {
        updateUiState: (state, action: PayloadAction<Partial<PortfolioSiteExplorerUIState>>) => {
            return { ...state, ...action.payload };
        },
        setHoveredSite: (state, action: PayloadAction<string | null>) => {
            state.hoveredSiteId = action.payload;
        },
        setSelectedSite: (state, action: PayloadAction<string | null>) => {
            state.selectedSiteId = action.payload;
        },
        setSelectedMetric: (state, action: PayloadAction<string>) => {
            state.selectedMetric = action.payload;
        },
    },
});

export const { updateUiState, setHoveredSite, setSelectedSite, setSelectedMetric } = portfolioSiteExplorerSlice.actions;

export default portfolioSiteExplorerSlice.reducer;
